/* Сама .page больше не носит отступов: на мобильном шапку (MobileShellHeader)
   нужно рисовать во всю ширину экрана, впритык к краям, а не внутри общего
   поля страницы — иначе полоса с логотипом не была бы полноширинной. Отступы
   переехали в .content, который оборачивает всё, что идёт после шапки. */
.page {
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  background: var(--bg);
  color: var(--text);
}

/* flex: 1 — растягивается на всё, что осталось от .page под шапкой: без
   этого .guestWrap ниже (flex: 1 внутри уже этого контейнера, не .page)
   не заполнял бы высоту экрана и гостевая карточка не центрировалась бы
   по вертикали, как раньше, когда .guestWrap был прямым потомком .page. */
.content {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: var(--sp-6);
  padding: var(--sp-7) var(--sp-6);
}

/* Десктопная шапка: знак, заголовок, кнопка аккаунта. На мобильном её вместо
   этого рисует MobileShellHeader — она живёт вне .content, а эта версия на
   узком экране не рендерится вовсе (см. TripsPage.tsx). Заголовок растянут
   флексом — он и раздвигает знак слева от кнопки аккаунта справа, без
   магических отступов. */
.header {
  display: flex;
  align-items: center;
  gap: var(--sp-5);
}

/* ── Разделы списка ──────────────────────────────────────────────────────── */

.group {
  display: flex;
  flex-direction: column;
  gap: var(--sp-4);
}

.groupTitle {
  margin: 0;
  color: var(--text-3);
  font-size: var(--fs-xs);
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.title {
  flex: 1;
  min-width: 0;
  font-size: var(--fs-xl);
  font-weight: 600;
}

.toolbar {
  display: flex;
  align-items: center;
  gap: var(--sp-5);
}

.back {
  color: var(--text-3);
  font-size: var(--fs-sm);
}

.muted {
  margin: 0;
  color: var(--text-3);
  font-size: var(--fs-md);
}

/* Гостевой экран — пустое состояние: у гостя тут нет и не может быть списка,
   поэтому вместо шапки с прижатым под ней абзацем вся оставшаяся высота
   страницы (flex-колонка .page) отдана одной центрированной карточке. */
.guestWrap {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.guestCard {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--sp-5);
  width: 100%;
  max-width: 42ch;
  padding: var(--sp-8);
  background: var(--surface);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius-lg);
}

.guestTitle {
  margin: 0;
  font-size: var(--fs-xl);
  font-weight: 600;
}

/* Кнопка входа — главный элемент карточки, а не приписка после абзаца:
   во всю ширину и крупнее обычной .btn. */
.guestSignIn {
  align-self: stretch;
  justify-content: center;
  padding: var(--sp-4) var(--sp-6);
  font-size: var(--fs-lg);
}

.list {
  display: flex;
  flex-direction: column;
  gap: var(--sp-4);
  margin: 0;
  padding: 0;
  list-style: none;
}

/* Строка поездки: название и даты слева, действия справа. */
.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-5);
  padding: var(--sp-5);
  background: var(--surface);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius-lg);
}

/* Открытая поездка помечена цветной кромкой слева: в списке из десятка строк
   нужно с одного взгляда видеть, где ты сейчас. */
.rowOpen {
  border-left: 3px solid var(--focus);
}

.rowMain {
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
  min-width: 0;
}

/* Название — кнопка: по нему открывают поездку, поэтому оно кликабельно
   целиком, а не только маленькая кнопка справа. */
.name {
  padding: 0;
  background: transparent;
  border: none;
  color: var(--text);
  font-size: var(--fs-lg);
  font-weight: 600;
  text-align: left;
  cursor: pointer;
}

.name:hover {
  text-decoration: underline;
}

.nameInput {
  max-width: 320px;
  font-size: var(--fs-lg);
  font-weight: 600;
}

/* Строка даты + кнопка «ⓘ»: дата последней правки коротко, всё остальное
   (создание, роль, соавторы, ссылка) — в поповере по клику на кнопку. */
.meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--sp-3);
  margin: 0;
  color: var(--text-3);
  font-size: var(--fs-sm);
}

.updated {
  color: var(--text-2);
}

.openBadge {
  padding: 1px var(--sp-3);
  border-radius: var(--radius);
  background: var(--surface-2);
  border: var(--bw) solid var(--border-strong);
  color: var(--text-2);
  font-size: var(--fs-xs);
}

.rowActions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: var(--sp-3);
  flex: none;
}

/* ── Мобильный вид (порог продублирован в ui/shell/useIsMobile.ts) ────────
   Строка перестаёт быть строкой: действия уезжают под название, а сам ряд
   кнопок переносится по ширине (flex-wrap уже задан в .rowActions выше) —
   пять кнопок с иконками и подписями ни на одном телефоне в одну линию не
   встанут, и вместо горизонтальной прокрутки они просто идут в два-три ряда. */
@media (max-width: 720px) {
  .content {
    padding: var(--sp-5) var(--sp-4);
  }

  .row {
    flex-direction: column;
    align-items: stretch;
    gap: var(--sp-4);
  }

  .rowActions {
    justify-content: flex-start;
  }

  /* Тач-зона не меньше 44px — палец менее точен, чем курсор, которым эти же
     кнопки жмут на десктопе при .btn-sm высотой поменьше. */
  .actionBtn {
    min-height: 44px;
  }

  .nameInput {
    max-width: none;
  }

  /* Единственное действие в полосе — во всю ширину, а не на ширину подписи. */
  .create {
    width: 100%;
    justify-content: center;
  }

  /* Карточка приглашения на узком экране — без огромных отступов дорогого
     десктопного варианта, но всё ещё явно карточка, а не текст вплотную к краям. */
  .guestCard {
    max-width: none;
    padding: var(--sp-6) var(--sp-5);
  }
}
